Object.defineProperty(exports, "__esModule", {
  value: true
});
var warning = process.env.NODE_ENV === 'production' ? function () {} : function (condition, message) {
  if (!condition) {
    console.error('Warning: ' + String(message));
  }
};

exports['default'] = warning;


//////////////////
// WEBPACK FOOTER
// ./node_modules/formera/lib/helpers/warning.js
// module id = 43
// module chunks = 0